import { get, omit } from "lodash"
import { DESC, orderState } from "helpers/sorts"
import { createSelector } from "reselect"
import { createQueryStringSelector } from "selectors/queryString"
import { createDefaultReducer } from "helpers/reducers"

export function mapContributorsGroupDropDown({ group, details }, selected, selectedOption, selectedGroup, contributorsGrouping) {
  // Replace element 0 with a new object rather than set([...arr], "0.label", …): the spread
  // copies the array but keeps the same element refs, so set() would mutate the shared
  // (module-level) column-config object in place.
  if (selectedGroup) {
    return [{ ...group[0], label: get(contributorsGrouping, "label") }, ...group.slice(1)]
  }
  if (selected) {
    return [{ ...details[0], label: get(selectedOption, "label") }, ...details.slice(1)]
  }

  return group
}

export const createDetailActions = (trackingKey) => ({
  setSortOrder: {
    props: ["contributorsSort"],
    track: true,
    trackType: `composite-analyze-${trackingKey}-contributors-sorting`,
    trackPayload: ({ contributorsSort }) => ({ by: get(contributorsSort, "by"), current: contributorsSort }),
  },
  setGroupSortOrder: {
    props: ["groupSort"],
    track: true,
    trackType: `composite-analyze-${trackingKey}-contributors-group-sorting`,
    trackPayload: ({ groupSort }) => ({ order: get(groupSort, "order") }),
  },
  showContributorCategory: {
    props: ["category"],
    track: true,
    trackType: `composite-analyze-${trackingKey}-contributors-group-selected`,
    trackPayload: ({ category }) => ({ type: get(category, "label") }),
  },
  hideContributorCategory: {
    track: false,
  },
  showGroup: {
    props: ["group"],
    track: true,
    trackType: `composite-analyze-${trackingKey}-contributors-group-selected`,
    trackPayload: ({ group: { name } }) => ({ label: name }),
  },
  hideGroup: [],
})

export const handleShowContributorCategory = (state, { category }) => ({ ...state, contributorCategory: get(category, "id") })
export const handleHideContributorCategory = (state) => omit(state, ["contributorCategory", "groupSort", "contributorsSort", "contributorPage"])
export const handleGroupSort = (state, { order }) => ({ ...state, groupOrder: { ...state.groupOrder, order } })
export const handleShowGroup = (state, { group }) => ({ ...state, contributorGroup: get(group, "id") })
export const handleHideGroup = (state) => omit(state, ["contributorGroup", "contributorPage"])
export const handleSetSortOrder = createDefaultReducer()
export const handleSetGroupSortOrder = createDefaultReducer()
export const handleSetPage = (state, { page }) => {
  // page numbers to start at 1 instead of 0
  return { ...state, contributorPage: page > 0 ? page + 1 : null }
}

const DEFAULT_ORDER_SORT = orderState("viewType", DESC)
const DEFAULT_GROUP_SORT_ORDER = { by: "value", order: "desc" }
export const getSortOrder = createQueryStringSelector("contributorsSort", DEFAULT_ORDER_SORT)
export const getGroupSortOrder = createQueryStringSelector("groupSort", DEFAULT_GROUP_SORT_ORDER)
export const getSelectedContributorCategoryId = createQueryStringSelector("contributorCategory")

const getRawPage = createQueryStringSelector("contributorPage", 1, { as: "number" })
export const getPage = createSelector(
  [getRawPage],
  page => page - 1,
)
